import api from '../api/axios';

// Server-side printing (CUPS on the API host). Admin-only feature.

const getServerPrinters = () => {
  return api.get('/print/printers');
};

const addServerPrinter = ({ name, uri, description, driver, resolution }) => {
  return api.post('/print/printers', { name, uri, description, driver, resolution });
};

const removeServerPrinter = (name) => {
  return api.delete(`/print/printers/${encodeURIComponent(name)}`);
};

const setDefaultServerPrinter = (name) => {
  return api.post(`/print/printers/${encodeURIComponent(name)}/default`);
};

const testServerPrinter = (name) => {
  return api.post(`/print/printers/${encodeURIComponent(name)}/test`);
};

// Render the proposal batch server-side and send it to a server printer
const printBatchOnServer = ({ ids, installDate, printer, copies, duplex }) => {
  return api.post('/print/proposal-batch', { ids, installDate, printer, copies, duplex });
};

const printServices = {
  getServerPrinters,
  addServerPrinter,
  removeServerPrinter,
  setDefaultServerPrinter,
  testServerPrinter,
  printBatchOnServer,
};

export default printServices;
